import React from 'react'
//import EventInvite from './EventInvite'
export default class Event extends React.Component {
  render () {
    return (<h1>Odaberi datum i zakaži! </h1>)
  }
}



// WEBPACK FOOTER //
// ./src/components/Event.js